import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/workDetails`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/workDetails/${id}?include=workItem`, options)
        .then(response => {
            let workDetails = jsona.deserialize(response.data);
            delete workDetails.links;
            return workDetails;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/workDetails/${id}`, options)
        .then(response => {
            let workDetails = jsona.deserialize(response.data);
            delete workDetails.links;
            return workDetails;
        });
}

function add (workDetail) {
    const payload = jsona.serialize({
        stuff: workDetail,
        includeNames: 'workItem'
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/workDetails`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (workDetails) {
    const payload = jsona.serialize({
        stuff: workDetails,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/workDetails/${workDetails.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/workDetails/${id}`, options);
}

export default {
    list,
    get,
    show,
    add,
    update,
    destroy
};

